// removed by extract-text-webpack-plugin
module.exports = {"trivia-text-color":"#969696","controlGroup":"_3CjURh9XQanMhdevQcy1r0","selectGroup":"_3Uy8aT0VLHPqbU28YDq44q","update-form":"_1tLPsKKsStzVa1PAWTnY3U","pass-message":"_2qo6BOGos7zDtSayCF-slg","help-message":"_2Y6x_UAvIfM_TRqUQjzvmW"};


//////////////////
// WEBPACK FOOTER
// ./src/views/wizard/isolate/gtable_iso/style.css
// module id = 248
// module chunks = 0